import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Account } from '../../store/account.model';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { ResponseStatus, IStatusMessage, EditGrid } from '../../../shared';
import { ReplaySubject } from 'rxjs';
import { AccountPostingType } from '../store';
import { SelectItem } from '../../../shared/efaact-primeng.module';
@Component({
    selector: 'ef-posting-account',
    templateUrl: './posting-account.component.html',
    styleUrls: ['./posting-account.component.scss'],
    standalone: false
})
export class PostingAccountComponent
    extends EditGrid<AccountPostingType>
    implements OnInit {
    @Input() accounts: Account[];
    @Input() postingItems: SelectItem[];
    postingAccounts: SelectItem[];
    public editing: AccountPostingType = {} as AccountPostingType;
    cloned: { [i: number]: AccountPostingType } = {};
    constructor(private log: LoggingService) {
        super();
    }
    ngOnInit() {}
    onEditInit($event: { data: AccountPostingType }) {
        this.editing = { ...$event.data };
    }
    onRowEditInit(item: AccountPostingType) {
        this.postingAccounts = this.accounts
            .filter(
                x => x.AccountType === item.AccountType || !item.AccountType
            )
            .map(x => ({
                label: x.AccountCode,
                value: x.AccountListID
            }));
        this.cloned[item.PostingType] = { ...item };
        this.editing = item;
        this.log.verbose({
            type: 'PostingAccountComponent:onRowEditInit',
            postingType: item,
            clonedPostingTypes: this.cloned,
            editing: this.editing
        });
    }
    onRowEditSave(item: AccountPostingType) {
        // validation
        if (item && item.ListID) {
            this.log.verbose({
                type: 'PostingAccountComponent:onRowEditSave',
                r: item,
                clonedPostingTypes: this.cloned
            });
            item.Status.StatusCode = ResponseStatus.Loading;
            item.Status.Message = 'Saving';
            this.SaveItem.next([item]);
            delete this.cloned[item.PostingType];
            delete this.editing;
        }
    }
    onRowEditCancel(item: AccountPostingType) {
        this.log.verbose({
            type: 'PostingAccountComponent:onRowEditCancel',
            item,
            clonedPostingTypes: this.cloned
        });
        const index = (this.items as AccountPostingType[]).findIndex(
            x => x.PostingType === item.PostingType
        );
        if (index >= 0) {
            this.items.splice(index, 1, this.cloned[item.PostingType]);
        }
        this.items = [...this.items];

        delete this.cloned[item.PostingType];
        delete this.editing;
    }
    getAccountsForPosting(item: AccountPostingType) {
        this.log.verbose({
            type: 'PostingAccountComponent:getAccountsForPosting',
            item,
            accounts: this.accounts
        });
        return this.accounts
            .filter(
                x => x.AccountType === item.AccountType || !item.AccountType
            )
            .map(x => ({
                label: x.AccountCode,
                value: x.AccountListID
            }));
    }
}
